import { useContext } from "react";
import { useRoutes } from "react-router";
import routes from "../routes";
import { AuthContext } from "src/app/contexts/AuthContext";
import LoadingComponent from "./LoadingComponent";
import { LoadingContext } from "../contexts/LoadingContext";

const Homepage = () => {
	const { authData } = useContext(AuthContext);
	const currentRoute = useRoutes(routes(authData));
	const { loadingData } = useContext(LoadingContext);

	return (
		<>
			{currentRoute}
			{loadingData.is_loading && (
				<div style={{ display: "absolute", justifyContent: "center" }}>
					<LoadingComponent loadingMessage={loadingData.message} />
				</div>
			)}
		</>
	);
};

export default Homepage;
